export default __webpack_public_path__ + "static/media/settings.b45e277d.jpg";